import instance from "../axiosConfig";
import { ElementComment, ElementCommentItem, PageComment, PageCommentItem } from "./models";

export class CommentsService {
    private regionCode: string;

    constructor(regionCode: string) {
        this.regionCode = regionCode;
    }

    getElementComments = async (): Promise<ElementComment[]> => {
        const response = await instance.get<ElementComment[]>(`api/admin/${this.regionCode}/comments`);

        return response.data;
    };

    getPageComments = async (): Promise<PageComment[]> => {
        const response = await instance.get<PageComment[]>(`api/admin/${this.regionCode}/comments/pages`);

        return response.data;
    };

    getForElement = async (elementId: string, languageCode: string): Promise<ElementCommentItem[]> => {
        const response = await instance.get<ElementCommentItem[]>(
            `api/admin/${this.regionCode}/comments/language/${languageCode}/elementId/${elementId}`
        );

        return response.data;
    };

    getForPage = async (slug: string, languageCode: string): Promise<PageCommentItem[]> => {
        const response = await instance.get<PageCommentItem[]>(
            `api/admin/${this.regionCode}/comments/language/${languageCode}/pages/${slug}`
        );

        return response.data;
    };

    markAsRead = async (commentId: string): Promise<boolean> => {
        const response = await instance.post(`/api/admin/${this.regionCode}/comments/${commentId}/markasread`, null, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.status >= 200 && response.status < 300;
    };

    delete = async (commentId: string): Promise<boolean> => {
        const response = await instance.delete(`/api/admin/${this.regionCode}/comments/${commentId}`);

        return response.status >= 200 && response.status < 300;
    };
}
